import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'

import isEmpty from 'lodash/isEmpty'
import {
    noop,
} from 'lodash'
import {
    TableFilterParams,
} from 'app/types/common.types'

import {
    useTableActionsContext,
} from '../TableActionsContext'
import useStyles from './BulkUploadPopupWrapper.styles'

type Props = {
    dialogTitle?: string,
    classNames?: {
        title?: string,
        content?: string,
        paper?: string,
    },
    onClose?: () => void,
    renderChildren: (data: {
        closePopup: () => void,
        filtersData: TableFilterParams
    }) => JSX.Element,
}

const BulkUploadPopupWrapper = (
    {
        dialogTitle = 'BULK UPDATE',
        classNames = {},
        onClose = noop,
        renderChildren,
    }: Readonly<Props>,
) => {
    const {
        cx,
        classes,
    } = useStyles()

    const {
        bulkUploadData,
        setBulkUploadData,
        invalidateTableDataRef,
    } = useTableActionsContext()

    const handleClose = () => {
        invalidateTableDataRef.current?.()
        setBulkUploadData(null)
        onClose()
    }

    return (
        <Dialog
            open={bulkUploadData && !isEmpty(bulkUploadData)}
            classes={{
                paper: classNames.paper || classes.paper,
            }}
        >
            <DialogTitle classes={{
                root: cx(classes.title, classNames.title),
            }}
            >
                {dialogTitle.toUpperCase()}
            </DialogTitle>
            <DialogContent className={cx(classes.dialogContent, classNames.content)}>
                {renderChildren({
                    closePopup: handleClose,
                    filtersData: bulkUploadData,
                })}
            </DialogContent>
        </Dialog>
    )
}

export default BulkUploadPopupWrapper
